export default function createGeoUri(lat, lng, name) {
  let url = "https://www.google.com/maps/search/PureGym";
  if (name) url += "+" + name;
  if (
    typeof lat == "number" &&
    !isNaN(lat) &&
    !Number.isInteger(lat) &&
    typeof lng == "number" &&
    !isNaN(lng) &&
    !Number.isInteger(lng)
  ) {
    url += "/@" + lat + "," + lng + ",15z";
  }
  return url;
}
